import WrapperService from "@/modules/core/services/wrapper-service";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/process"

const serviceName = "Process-Service: ";
export default class ProcessService {
  static async readAllFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static async readAllManualFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static async readFromAPI(id, successF, errorF) {
    await WrapperService.get(API_URL + "/" + id, null, serviceName, successF, errorF);
  }

  static async readProcessStepsFromAPI(processId, successF, errorF) {
    await WrapperService.get(API_URL + "/" + processId + "/step", null, serviceName, successF, errorF);
  }

  static postToAPI(process, successF, errorF) {
    WrapperService.post(API_URL, process, serviceName, successF, errorF);
  }

  static putToAPI(process, successF, errorF) {
    WrapperService.put(API_URL + "/" + process.id, process, serviceName, successF, errorF);
  }

  static deleteFromAPI(process, successF, errorF) {
    WrapperService.delete(API_URL + "/" + process.id, serviceName, successF, errorF);
  }
}
